export const PRODUCT_NOMENCLATURE: Record<string, string> = {
    "Arth Jeevika": "Arth - Women Group Loan",
    "Arth Pay": "Arth Pay",
    "Arth Pay Loan": "Arth - Pay Loan",
    "Arth Swabhiman": "Arth - Small Vendor Loan",
    "Arth Vridhi": "Arth - Small Business Loan",
    "Arth Vridhi - Goat Trust": "Arth - Small Business Loan",
    "Arth Vridhi COVID": "Arth - Small Business Loans",
    "Arth Vridhi Pay": "Arth - Pay Loan",
    "Business Prime": "Arth - Business Prime",
    "Credit": "Credit",
    "Housing Loan": "Arth - AHL",
    "Insurance": "Arth - Insurance",
    "LG_LeadGen": "Arth - Lead Gen",
    "Loan Against Property": "Arth - mLAP",
    "Prepaid Account": "Arth - Prepaid Account",
    "Secured Loan": "Arth - mLAP",
    "Arth Sanchay": "Arth - mInvestments",
    "Balance Transfer": "Arth - BT",
    "Prime Loan Against Property": "Arth - pLAP",
    "Arth Rahat Loans": "Arth - Small Business Loans",
    "Avatar Loans": "Arth - Gig Loans",
  };